import { store } from 'src/app/store';
import { createAreaAudio } from './areaAudio';
import { createPointAudio } from './pointAudio';
import { createPreloadAudio } from './preloadAudio';

store.subscribe(onStateChange);

let instantiated = false;

function onStateChange() {
  if (instantiated) return;

  const state = store.getState();
  if (!state.navigation.soundEnabled) return;

  const AudioContext = window.AudioContext || window.webkitAudioContext;
  const audioContext = new AudioContext();
  createAreaAudio(audioContext);
  createPointAudio(audioContext);
  createPreloadAudio(audioContext);
  instantiated = true;
}
